import React, { useEffect, useState } from "react";
import { useRef } from "react";
import Grid from "@mui/material/Grid";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import axiosInstance from "../../../../lib/axios";
import {
  Autocomplete,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
} from "@mui/material";
import CrudButtons from "../../../../GlobalFunction/CrudButtons";
import { z } from "zod";
import { formatDeleteErrorMessage } from "../../../../GlobalFunction/ErrorMessageHelper";
import { useReactToPrint } from "react-to-print";
import { getFormMode } from "../../../../lib/helpers";
import CustomAutoCompleteNew from "../../../AutoComplete/CustomAutoCompleteNew";
import CustomAutocomplete from "../../../AutoComplete/AutocompletewithoutIcon";
import ReportTable from "../../../../atoms/ReportFolder/ReportTable";

const FORM_MODE = getFormMode();
const INIT_STATE = {
  TktCategoryId: "",
  TktSubCategoryName: "",
  Abrv: "",
  Remark: "",
  assetFlag: "no",
  itemId: "",
  Status: FORM_MODE.add ? "1" : "0",
};

const subcategoryFormSchema = z
  .object({
    TktCategoryId: z.number().min(1, "Ticket category is required"),
    TktSubCategoryName: z.string().min(1, "Ticket Subcategory is required"),
    Abrv: z.string().optional(),
    Remark: z.string().optional(),
    assetFlag: z.string().optional(), // "yes" or "no"
    itemId: z.union([z.number(), z.string()]).optional(), // Temporarily allow string if formData is ""
    Status: z.enum(["1", "0"]).optional(),
  })
  .superRefine((data, ctx) => {
    if (data.assetFlag === "yes" && (!data.itemId || Number(data.itemId) <= 0)) {
      ctx.addIssue({
        path: ["itemId"],
        message: "Item Name is required when Asset Flag is Yes",
        code: z.ZodIssueCode.custom,
      });
    }
  });
const columns = [
  { id: "RowNum", label: "Sr.No.", minWidth: 10 },
  { id: "TktCategoryName", label: "CategoryName", minWidth: 100 },
  { id: "TktSubCategoryName", label: "SubCategoryName", minWidth: 100 },
  { id: "Abrv", label: "ShortName", minWidth: 100 },
  { id: "Remark", label: "Remark", minWidth: 100 },
  { id: "Status", label: "Status", minWidth: 50 },
];
const TicketSubCategory = () => {
  const [formData, setFormData] = useState(INIT_STATE);
  const [itemNames, setItemNames] = useState([]);

  const [error] = useState({
    TktCategoryName: false,
  });

  const navigate = useNavigate();
  const [isFormDisabled, setIsFormDisabled] = useState(true);
  const [categories, setcategories] = useState([]);
  const location = useLocation();
  const [currentTktSubCategoryId, setCurrentTktSubCategoryId] = useState(null);
  const [mode, setMode] = useState("view");
  const [setLastInsertedCompId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [UserId] = useState(sessionStorage.getItem("UserId"));
  const [Status, setStatus] = useState("1");
  const [isRefCategory, setIsRefCategory] = useState(false);

  const [DataForPrint, setDataForPrint] = useState({});
  const [rows, setRows] = useState([]);
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({ contentRef });

  const TktCategoryNameRef = useRef(null);
  const TktSubCategoryNameRef = useRef(null);
  const abrvRef = useRef(null);
  const remarkRef = useRef(null);

  const openCategory = () => {
    window.open("/ticket-category")
  }
  useEffect(() => {
    const getRow = async () => {
      const params = {
        start: 1,
        PageSize: 1,
        SearchText: "",
      };

      try {
        const res = await axiosInstance.post('TktSubCategory/getTktSubCategoryDashBoard', { params });

        if (res.data && res.data.Data) {
          setRows(res.data.Data);
          setDataForPrint(res.data.Data);
        } else {
          console.error('No data found in response');
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    getRow();
  }, []);
  const handleCategoryRefresh = async () => {
    setIsRefCategory(true);
    try {
      const response = await axiosInstance.get(
        `TktCategory/getTktCategorydrp`
      );
      const {
        data: { Status, Data, responseStatusCode },
      } = response;
      if (Status === 0 && responseStatusCode === 1) {
        setcategories(Data);
      } else {
        setcategories([]);
      }
    } catch (error) {
      console.error("Error fetching CategoryName. Please try again.", {
        autoClose: 1000,
      });
    } finally {
      setTimeout(() => {
        setIsRefCategory(false);
      }, 300);
    }
  }

  const handleChangeStatus = (event) => {
    const updatedStatus = event.target.checked ? "1" : "0";
    setStatus(updatedStatus);
    setFormData((prevState) => ({
      ...prevState,
      Status: updatedStatus,
    }));
  };

  const handleChangeAssetFlag = (event) => {
    const checked = event.target.checked;
    setFormData((prevState) => ({
      ...prevState,
      assetFlag: checked,
      itemId: checked ? prevState.itemId : "",
    }));
    if (checked) {
    }
  };

  useEffect(() => {
    if (location.state && location.state.TktSubCategoryId) {
      setCurrentTktSubCategoryId(location.state.TktSubCategoryId);
      fetchSubCategoryData(location.state.TktSubCategoryId);
      setMode("view");
    } else {
      setMode("add");
      setIsFormDisabled(false);
    }
  }, [location]);

  const fetchSubCategoryData = async (id, flag = "R") => {
    try {
      const response = await axiosInstance.post(
        `TktSubCategory/RetriveTktSubCategory`,
        {
          TktSubCategoryId: parseInt(id),
          Flag: flag,
        }
      );
      const {
        data: { Status, Message, Data, responseStatusCode },
      } = response;
      if (Status === 0 && responseStatusCode === 1 && Array.isArray(Data)) {
        const data = Data[0];
        setFormData({
          TktCategoryId: data?.TktCategoryId,
          TktSubCategoryName: data?.TktSubCategoryName,
          Abrv: data?.Abrv ?? "",
          Remark: data?.Remark ?? "",
          Status: data?.Status,
          assetFlag: data?.AssetFlag === "Y" ? "yes" : "no", // Update this line
          itemId: data?.AssetItmId || "",
        });
        if (data?.AssetFlag === "Y") {
          setItemNames([
            {
              ItmId: data.AssetItmId,
              ItmName: data.ItmName?.trim(),
            },
          ]);

        }
        setStatus(data.Status.toString());
        setIsFormDisabled(true);
        setCurrentTktSubCategoryId(Data[0]?.TktSubCategoryId);
      } else if (Status === 1 && responseStatusCode === 2) {
        toast.info(Message, { autoClose: 1000 });
      } else {
        toast.error(Message, { autoClose: 1000, });
      }
    } catch (error) {
      console.error("Error fetching subcategory master data:", error);
    }
  };
  //category drp
  useEffect(() => {
    const fetchCategoryName = async () => {
      try {
        const response = await axiosInstance.get(
          `TktCategory/getTktCategorydrp`
        );
        const {
          data: { Status, Data, responseStatusCode },
        } = response;
        if (Status === 0 && responseStatusCode === 1) {
          setcategories(Data);
        } else {
          setcategories([]);
        }
      } catch (error) {
        console.error("Error fetching CategoryName. Please try again.");
      }
    };

    fetchCategoryName();
  }, []);

  const handlePrevious = async () => {
    if (currentTktSubCategoryId && currentTktSubCategoryId > 1) {
      await fetchSubCategoryData(currentTktSubCategoryId, "P");
    }
  };

  const handleNext = async () => {
    if (currentTktSubCategoryId) {
      await fetchSubCategoryData(currentTktSubCategoryId, "N");
    }
  };

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    if (type === "checkbox") {
      setFormData((prevState) => ({
        ...prevState,
        [name]: checked,
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
    if (name === "subcategory") {
      setFormData((prevState) => ({
        ...prevState,
        state: "",
      }));
    }

    if (name === "subcategory" && value !== "") {
      setTimeout(() => {
        remarkRef.current.focus();
      }, 100000);
    }
  };
  // const handleItemNameChange = (event) => {
  //   const value = event.target.value;
  //   setFormData((prevState) => ({
  //     ...prevState,
  //     itemId: value,
  //   }));
  // };
  const handleItemNameChange = (event) => {
    const value = event.target.value;
    setFormData((prevState) => ({
      ...prevState,
      itemId: Number(value),
    }));
  };


  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      if (event.target === TktCategoryNameRef.current) {
        TktSubCategoryNameRef.current.focus();
      } else if (event.target === TktSubCategoryNameRef.current) {
        abrvRef.current.focus();
      } else {
        remarkRef.current.focus();
      }
    }
  };

  const handleSubmit = async () => {
    const result = subcategoryFormSchema.safeParse(formData);
    if (!result.success) {
      toast.info("Please fill in all required inputs correctly.", {
        autoClose: 1000,
      });
    }
    const { data } = result;
    try {
      const payload = {
        TktCategoryId: parseInt(data.TktCategoryId),
        TktSubCategoryName: data.TktSubCategoryName,
        ServiceProvId: 1,
        WardenId: 1,
        Abrv: data.Abrv,
        Remark: data.Remark,
        Status: data.Status,
        AssetFlag: data.assetFlag === "yes" ? 'Y' : 'N',
        // AssetItmId: data.itemId,
        AssetItmId: data.assetFlag === "yes" ? parseInt(formData.itemId) : 1,

      };

      let response;
      if (mode === "edit") {
        payload.TktSubCategoryId = currentTktSubCategoryId;
        payload.UpdatedBy = parseInt(UserId, 10);
        response = await axiosInstance.patch(
          `TktSubCategory/UpdateTktSubCategory`,
          payload
        );
      } else {
        payload.CreatedBy = parseInt(UserId, 10);
        response = await axiosInstance.post(
          `TktSubCategory/InsertTktSubCategory`,
          payload
        );
      }
      const {
        data: { Status, Message, Data, responseStatusCode },
      } = response;
      if (Status === 0 && responseStatusCode === 1) {
        toast.success(Message, { autoClose: 1000 });
        if (mode === "add") {
          await fetchSubCategoryData(Data);

          setMode("view");
          setIsFormDisabled(true);
          setCurrentTktSubCategoryId(Data);
        } else {
          setMode("view");
        }
        setIsFormDisabled(true);
      } else {
        toast.error(Message);
      }
    } catch (error) {
      console.error("Error saving/updating subcategory master:", error);
    }
  };

  const handleEdit = () => {
    setMode("edit");
    setIsFormDisabled(false);
  };

  const handleAdd = () => {
    setMode("add");
    setIsFormDisabled(false);
    setFormData({
      TktCategoryName: "",
      TktSubCategoryName: "",
      Abrv: "",
      assetFlag: "no",
      Remark: "",
      Status: "1",
    });

    setCurrentTktSubCategoryId(null);

    setTimeout(() => {
      if (TktCategoryNameRef.current) {
        TktCategoryNameRef.current.focus();
      }
    }, 100);
  };

  const handleCancel = async () => {
    if (mode === "add") {
      try {
        await fetchSubCategoryData(1, "L");
        setMode("view");
        setIsFormDisabled(true);
      } catch (error) {
        toast.error('Error occurred while cancelling. Please try again.');
      }
    } else if (mode === "edit") {
      if (currentTktSubCategoryId) {
        await fetchSubCategoryData(currentTktSubCategoryId, "R");
      }
      setMode("view");
      setIsFormDisabled(true);
    }
  };
  const handleExit = () => {
    navigate("/ticket-subcategory-table");
  };

  const handleDeleteClick = () => {
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };
  const handleConfirmDelete = async () => {
    setOpenConfirmDialog(false);
    try {
      const response = await axiosInstance.post(
        `TktSubCategory/RetriveTktSubCategory`,
        {
          TktSubCategoryId: currentTktSubCategoryId,
          Flag: "D",
        }
      );
      if (response instanceof Error) {
        return console.error("Error: could not fetch subcategory");
      }
      const {
        data: { Status, Message, Data },
      } = response;
      if (Status === 0) {
        toast.success(Message, { autoClose: 1000 });
      } else {
        if (Array.isArray(Data) && Data.length > 0) {
          const msg = formatDeleteErrorMessage(Data);
          toast.error(msg, { autoClose: 1000 });
        } else {
          toast.error(Message, { autoClose: 1000 });
        }
      }
      await fetchSubCategoryData(currentTktSubCategoryId, "N");
      setMode("view");
      setIsFormDisabled(true);
    } catch (error) {
      console.error("Error deleting subcategory Master:", error);
    }
  };

  const handleAssetFlagChange = async (selected) => {
    if (selected === "yes") {
      setFormData((prevState) => ({
        ...prevState,
        assetFlag: "yes",
      }));
      // fetch item names from API
      try {
        const response = await axiosInstance.post(
          "http://43.230.196.22:8080/WebApi/api/MstItm/GetMstItmdrp",
          {
            ItmSubGrpId: 1,
            Flag: "Asset",
          }
        );
        const { Status, Data, responseStatusCode } = response.data;
        if (Status === 0 && responseStatusCode === 1 && Array.isArray(Data)) {
          setItemNames(Data);
        } else {
          toast.error("Failed to fetch item names", { autoClose: 1000 });
          setItemNames([]);
        }
      } catch (error) {
        console.error("Error fetching item names", error);
        setItemNames([]);
      }
    } else if (selected === "no") {
      setFormData((prevState) => ({
        ...prevState,
        assetFlag: "no",
        itemId: "",
      }));
      setItemNames([]);
    }
  };
  const getItemValue = () => {
    const found = itemNames?.find((item) => item.ItmId === Number(formData.itemId)) || "";
    if (!found) return "";
    return {
      Id: found.ItmId,
      Name: found.ItmName
    }
  }
  const mobileHeight = formData.assetFlag === "yes" ? "630px" : "580px";
  return (
    <>
      <Box className="form-container"
        sx={{
          width: { xs: "calc(100vw - 60px)", sm: "100%", md: "100%" },
          maxWidth: { xs: "calc(100vw - 60px)", sm: "100%", md: "100%" },
          overflowX: "hidden",
          overflowY: { xs: "auto", sm: "hidden", md: "hidden" },
        }}>
        <ToastContainer />
        <Grid container spacing={2} sx={{
          width: { xs: "93%", sm: "80%", md: "80%" },
          height: { xs: mobileHeight, sm: "auto", md: 'auto' },
          margin: 'auto',
          marginTop: { xs: "60px", sm: 0, md: 'auto' },
          marginBottom: { xs: "110px", sm: 0, md: 'auto' },
          borderRadius: '8px',
          padding: { xs: '0px 5px 5px 5px', sm: '0px 20px 20px 20px' },
          backgroundColor: '#fff',
        }}>
          <Grid
            item
            xs={12}
            className="form_title"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "20px",
              flexDirection: { xs: "column", sm: "row", md: "row" },
              overflow: "hidden",
            }}
          >
            <Grid
              sx={{
                display: "flex",
                justifyContent: { xs: "center", sm: "flex-start" },
                marginBottom: { xs: "10px", sm: 0 },
              }}
            >
              <Button
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: "#635bff",
                  marginRight: { xs: "5px", sm: "10px" },
                  display: "block",
                }}
                className="three-d-button-previous"
                onClick={handlePrevious}
                disabled={
                  mode !== "view" ||
                  !currentTktSubCategoryId ||
                  currentTktSubCategoryId === 1
                }
              >
                <KeyboardArrowLeftIcon />
              </Button>

              <Button
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: "#635bff",
                  display: "block",
                }}
                className="three-d-button-next"
                onClick={handleNext}
                disabled={mode !== "view" || !currentTktSubCategoryId}
              >
                <NavigateNextIcon />
              </Button>
            </Grid>

            <Typography
              variant="h5"
              sx={{
                margin: "Auto",
                textAlign: { xs: "center", sm: "center" },
                fontSize: { xs: "24px", sm: "18px", md: "24px" },
              }}
            >
              SubCategory Master
            </Typography>
            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <CrudButtons
                moduleName="Ticket SubCategory"
                mode={mode}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onDelete={handleDeleteClick}
                onView={handlePrint}
                onExit={handleExit}
                onPrevious={handlePrevious}
                onNext={handleNext}
                readOnlyMode={mode === "view"}
              />
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            md={12}
            lg={12}
            sx={{
              display: "flex",
              justifyContent: "center",
              mx: 'auto',
            }}
          >
            <Grid
              container
              spacing={2}
              justifyContent="center"
              sx={{ maxWidth: "800px", width: "100%" }}
            >
              <Grid item xs={12} md={8}  >
                <Grid container spacing={2}>
                  <Grid item xs={12} md={12}>

                    <CustomAutoCompleteNew
                      id="TktCategoryName-select"
                      name="TktCategoryId"
                      options={categories}
                      value={categories.find((category) => category.Id === formData.TktCategoryId) || ''}
                      onChange={handleInputChange}
                      label={
                        <span>
                          Category Name <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      inputRef={TktCategoryNameRef}
                      disabled={isFormDisabled}
                      onAddClick={openCategory}
                      onRefreshClick={handleCategoryRefresh}
                      isRefreshing={isRefCategory} />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} md={8}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4}>
                    <TextField
                      id="CompAbrv"
                      name="Abrv"
                      label="ShortName"
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={formData.Abrv}
                      onChange={handleInputChange}
                      disabled={isFormDisabled}
                      inputRef={abrvRef}
                      onKeyDown={handleKeyPress}
                    />
                  </Grid>
                  <Grid item xs={12} md={8}>
                    <TextField
                      id="TktSubCategoryName"
                      name="TktSubCategoryName"
                      label={
                        <span>
                          SubCategoryName
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={formData.TktSubCategoryName}
                      onChange={handleInputChange}
                      disabled={isFormDisabled}
                      inputRef={TktSubCategoryNameRef}
                      onKeyDown={handleKeyPress}
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* Asset Flag Yes/No Checkboxes */}
              <Grid item xs={12} md={8}  >
                <Typography sx={{ fontWeight: 600, mb: 1 }}>Asset Flag</Typography>
                <Grid container
                  spacing={1}
                  alignItems="center"
                  gap={0.1}
                  flexWrap={{ xs: "nowrap", md: "wrap" }}
                  sx={{
                    display: 'flex',
                    flexDirection: { xs: "column", sm: "row", md: "row", lg: "row" }
                  }}
                >
                  <Grid
                    item
                    md={4}
                    xs={12}
                    sx={{
                      display: "flex",
                      alignItems: 'center',
                      gap: 0,
                      justifyContent: { xs: "flex-start", sm: "center", md: "center" }, // Align left on mobile, center on larger
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="assetFlag"
                          checked={formData.assetFlag === "yes"}
                          onChange={() => handleAssetFlagChange("yes")}
                          disabled={isFormDisabled}
                        />
                      }
                      label="Yes"
                      sx={{ margin: 0, padding: 0 }}
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="assetFlag"
                          checked={formData.assetFlag === "no"}
                          onChange={() => handleAssetFlagChange("no")}
                          disabled={isFormDisabled}
                        />
                      }
                      label="No"
                      sx={{ margin: 0, padding: 0 }}
                    />
                  </Grid>

                  {formData.assetFlag === "yes" && (
                    <Grid item md={8} xs={12} sx={{ width: '100%' }}>
                      <CustomAutocomplete
                        id="itemId-select"
                        name="itemId"
                        options={itemNames?.map(i => ({ Id: i.ItmId, Name: i.ItmName }))}
                        value={getItemValue()}
                        onChange={handleItemNameChange}
                        label={
                          <span>
                            Item Name {formData.assetFlag === "yes" && <span style={{ color: "red" }}>*</span>}
                          </span>
                        }
                        inputRef={null}
                        disabled={isFormDisabled}
                        fullWidth // Ensure autocomplete expands full width if it supports this prop
                      />
                    </Grid>
                  )}
                </Grid>

              </Grid>

              <Grid item xs={12} md={8}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={10}>
                    <TextField
                      fullWidth
                      label="Remark"
                      name="Remark"
                      value={formData.Remark}
                      onChange={handleInputChange}
                      variant="filled"
                      disabled={isFormDisabled}
                      className="custom-textfield"
                      inputRef={remarkRef}
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            disabled={isFormDisabled}
                            checked={Status === "1"}
                            onChange={handleChangeStatus}
                          />
                        }
                        label="Status"
                      />
                    </FormGroup>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_button"
            sx={{
              marginBottom: {
                xs: '10px',
                sm: '0px',
                md: '0px',
                lg: '0px',
              }
            }}
          >
            {mode === "view" && (
              <>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #d4d4d4, #ffffff)",
                  }}
                  onClick={handleAdd}
                  disabled
                >
                  Submit
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #a7c5e9, #ffffff)",
                  }}
                  onClick={handleEdit}
                  disabled
                >
                  Cancel
                </Button>
              </>
            )}
            {(mode === "edit" || mode === "add") && (
              <>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #635bff, #635bff)",
                  }}
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #635bff, #635bff)",
                  }}
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
              </>
            )}
          </Grid>
        </Grid>
      </Box>
      <div style={{ display: 'none' }}>
        {rows.length > 0 && (
          <ReportTable
            columns={columns}
            rows={rows}
            title="Ticket Subcategory Master"
            contentRef={contentRef}
            customStyles={{ backgroundColor: '#f5f5f5' }}
          />
        )}
      </div>
      {/* Delete Confirmation Modal */}
      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": {
                backgroundColor: "#1565c0",
                color: "white",
              },
            }}
            onClick={handleConfirmDelete}
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": {
                backgroundColor: "#1565c0",
                color: "white",
              },
            }}
            onClick={handleCloseConfirmDialog}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TicketSubCategory;


